/**
 * Derives the effective column list after applying steps[0..upToIndex-1].
 * Only tracks column name changes - no data processing.
 */
export function deriveColumnsAtStep(sourceColumns, steps, upToIndex) {
    let columns = [...sourceColumns];

    for (let i = 0; i < upToIndex; i++) {
        const step = steps[i];
        if (step.enabled === false) continue;
        columns = applyStepToColumns(columns, step);
    }

    return columns;
}

function applyStepToColumns(columns, step) {
    const { type, config } = step;
    if (!config) return columns;

    switch (type) {
        case 'RENAME_COLUMN': {
            const { column, newName } = config;
            if (!column || !newName) return columns;
            return columns.map(c => c === column ? newName : c);
        }

        case 'SPLIT_COLUMN': {
            const { column, maxParts } = config;
            if (!column) return columns;
            const idx = columns.indexOf(column);
            if (idx === -1) return columns;
            const parts = maxParts || 2;
            const newCols = [...columns];
            const generated = [];
            for (let j = 1; j <= parts; j++) generated.push(`${column}_${j}`);
            newCols.splice(idx, 1, ...generated);
            return newCols;
        }

        case 'MERGE_COLUMNS': {
            const { newColumnName } = config;
            if (!newColumnName) return columns;
            return [...columns, newColumnName];
        }

        case 'REMOVE_COLUMN': {
            const cols = config.columns || (config.column ? [config.column] : []);
            if (cols.length === 0) return columns;
            return columns.filter(c => !cols.includes(c));
        }

        case 'CALCULATE_FIELD': {
            const { newColumnName } = config;
            if (!newColumnName) return columns;
            return [...columns, newColumnName];
        }

        case 'PIVOT_AGGREGATE': {
            const groupBy = config.groupBy || [];
            const aggregations = config.aggregations || [];
            const aggregateColumns = aggregations
                .map(aggregation => aggregation.outputColumn)
                .filter(Boolean);
            if (groupBy.length === 0 && aggregateColumns.length === 0) return columns;
            return [...groupBy, ...aggregateColumns];
        }

        default:
            return columns;
    }
}
